import { create } from 'zustand';

interface State {
    currentPage: number;
    setCurrentPage: (page: number) => void;
    status: string;
    setStatus: (status: string) => void;
}

export const useLeadsStore = create<State>((set) => ({
    currentPage: 0,
    setCurrentPage: (page) => set({ currentPage: page }),
    status: '',
    setStatus: (status) => set({ status }),
}));
